// Firebase v8 / compat syntax, matching this web app.
import { db, fieldValue } from "./firebase.utils";

export function saveHeaderDetails(spaceId, stationId, patch) {
  const workspace = db.collection("space").doc(spaceId);
  const ref = stationId ? workspace.collection("stations").doc(stationId) : workspace;
  return ref.update(patch);
}

// Await the same legacy cleanup paths your supplied helpers use.
// This is NOT recursive deletion of modern task/note/chat subcollections.
export async function deleteHeaderProject(spaceId, stationId) {
  const ref = db.collection("space").doc(spaceId).collection("stations").doc(stationId);
  const task = ref.collection("tasks").doc("tasks");
  const comments = await task.collection("comments").get();
  for (let i = 0; i < comments.docs.length; i += 450) {
    const batch = db.batch();
    comments.docs.slice(i, i + 450).forEach(comment => batch.delete(comment.ref));
    await batch.commit();
  }
  await task.delete();
  await ref.collection("modules").doc("modules").delete();
  await ref.delete();
}

export async function deleteHeaderWorkspace(spaceId) {
  const ref = db.collection("space").doc(spaceId);
  const stations = await ref.collection("stations").get();
  for (const station of stations.docs) await deleteHeaderProject(spaceId, station.id);
  await ref.delete();
}

export function leaveHeaderWorkspace(spaceId, uid) {
  // Keep the two membership arrays consistent; owners cannot use this action.
  return db.collection("space").doc(spaceId).update({
    members: fieldValue.arrayRemove(uid),
    admins: fieldValue.arrayRemove(uid),
  });
}
